import type fetchNotificationCount from '../../../../hosting-server/src/booking/functions/fetchNotificationCount';
import { createServerQueryHook } from '../../core/hooks/serverHooksCreators';

const useNotificationCount = createServerQueryHook<
    typeof fetchNotificationCount
>('fetchNotificationCount');

export default useNotificationCount;
